// extracted by mini-css-extract-plugin
export default {"errorPopup":"ErrorPopup_errorPopup__9oKZK"};